import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from 'axios';
import { review_AiCommentServiceSetting } from "../../sample-data";

const initialState = {
  data: [],
  isLoading: true,
  error: "",
};

export const url = `https://jsonplaceholder.typicode.com/posts/1`;

export const fetchAiCommentServiceSetting = createAsyncThunk(
  "AiCommentServiceSettingSetting/fetchAiCommentServiceSetting",
  async (thunkApi, { rejectWithValue }) => {    
    await new Promise(resolve => setTimeout(resolve, 200));    
    return review_AiCommentServiceSetting;
    try {
      const response = await axios.get(url, {
        validateStatus: status => status >= 200 && status < 300,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(`Error: ${err.message}`);
    }
  }
);

export const sliceAiCommentServiceSetting = createSlice({
  name: "AiCommentServiceSettingSetting",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAiCommentServiceSetting.pending, (state) => {
        state.isLoading = true;
        state.error = ""; // Reset error on pending state
      })
      .addCase(fetchAiCommentServiceSetting.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = ""; // Reset error on successful fetch
      })
      .addCase(fetchAiCommentServiceSetting.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        console.log(state.error);
      });
  },
});

export const selectAiCommentServiceSettingData = (state) => state.AiCommentServiceSettingSetting.data;
export const selectIsLoading = (state) => state.AiCommentServiceSettingSetting.isLoading;
export const selectError = (state) => state.AiCommentServiceSettingSetting.error;

// Access data directly from state using getter functions within your components
// for example:
// const data = useSelector(state => state.AiCommentServiceSettingSetting.data);
/*
const { data, isLoading, error } = useSelector(state => ({
  data: state.AiCommentServiceSettingSetting.data,
  isLoading: state.AiCommentServiceSettingSetting.isLoading,
  error: state.AiCommentServiceSettingSetting.error,
}));
*/
export default sliceAiCommentServiceSetting.reducer; // Export the reducer
